export default "__VITE_ASSET__DegvAJch__"